import { RootPaths } from "../../App/paths";

export const ACCOUNTS_PATH = "accounts";
export const ACCOUNTS_BASE_PATH = `${RootPaths.APP_V2_HOME}/${ACCOUNTS_PATH}`;

export const PROFILE_PATH = "profile";
export const PROFILE_FULL_PATH = `${ACCOUNTS_BASE_PATH}/${PROFILE_PATH}`;

export const ACCOUNTS_DOCUMENTS_PATH = "documents";
export const ACCOUNTS_HCF_DOCUMENT_BY_ID_AND_NAME_PATH = "documents/:hcfId/:hcfName";
export const ACCOUNTS_DOCUMENT_DETAILS_PATH = "document-details";

export const ACCOUNTS_DOCUMENTS_FULL_PATH = `${ACCOUNTS_BASE_PATH}/${ACCOUNTS_DOCUMENTS_PATH}`;
export const ACCOUNTS_DOCUMENTS_DETAILS_FULL_PATH = `${ACCOUNTS_BASE_PATH}/${ACCOUNTS_DOCUMENT_DETAILS_PATH}`;

export const DELETE_ACCOUNT_PATH = "delete-account";
export const DELETE_ACCOUNT_FULL_PATH = `${ACCOUNTS_BASE_PATH}/${DELETE_ACCOUNT_PATH}`;

export const ACCOUNT_UPDATES_PATH = "updates";
export const ACCOUNT_UPDATES_FULL_PATH = `${ACCOUNTS_BASE_PATH}/${ACCOUNT_UPDATES_PATH}`;

export const JOB_SEARCH_AGREEMENT_PATH = "job-search-agreement";
export const JOB_SEARCH_AGREEMENT_FULL_PATH = `${ACCOUNTS_BASE_PATH}/${JOB_SEARCH_AGREEMENT_PATH}`;
